<template>
  <div v-if="show" class="drawer">
    <el-drawer destroy-on-close :visible.sync="show" size="800px" :show-close="false">
      <div class="drawer-show">
        <div class="drawer-show-header">
          <div class="drawer-show-header-body">
            <h2 class="fl drawer-show-add-name">
              <a href="javascript:void(0);" @click="copyName" class="copy-a" :data-clipboard-text="name">{{ name }}</a>
            </h2>
            <div class="fr">
              <el-button class="drawer-show-add-close" type="text" icon="el-icon-close" @click="show = false" />
            </div>
          </div>
        </div>
        <div class="drawer-show-body">
          <div style="margin-top: 20px">
            <el-tabs v-model="activeName" type="border-card">
              <el-tab-pane label="基本信息" name="基本信息">
                <div class="drawer-item">
                  <p class="drawer-item-name">矿发净重</p>
                  {{ data.primaryWeight + " 吨" }}
                </div>
                <div class="drawer-item">
                  <p class="drawer-item-name">毛重</p>
                  {{ data.grossWeight + " 吨" }}
                </div>
                <div class="drawer-item">
                  <p class="drawer-item-name">一次时间</p>
                  {{ data.firstTime }}
                </div>
                <div class="drawer-item">
                  <p class="drawer-item-name">皮重</p>
                  {{ data.tareWeight + " 吨" }}
                </div>
                <div class="drawer-item">
                  <p class="drawer-item-name">二次时间</p>
                  {{ data.secondTime }}
                </div>
                <div class="drawer-item">
                  <p class="drawer-item-name">净重</p>
                  {{ data.netWeight + " 吨" }}
                </div>
                <div class="drawer-item">
                  <p class="drawer-item-name">亏吨</p>
                  {{ data.lossWeight + " 吨" }}
                </div>
                <vxe-table align="center" :data="data.weighRecordDtoList">
                  <template #empty>
                    <el-empty></el-empty>
                  </template>
                  <vxe-table-column field="weighAddress" title="过磅地址" width="100"></vxe-table-column>
                  <vxe-table-column title="过磅图片" min-width="715">
                    <template slot-scope="scope">
                      <div
                        v-if="(scope.row.photoUrlList && scope.row.photoUrlList.length == 0) || !scope.row.photoUrlList">
                        <img :src="noImg" class="pic" width="160" height="90" />
                      </div>
                      <div v-else>
                        <viewer :images="scope.row.photoUrlList">
                          <img v-for="src in scope.row.photoUrlList" :src="src" :key="src" width="160" height="90" />
                        </viewer>
                      </div>
                    </template>
                  </vxe-table-column>
                </vxe-table>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      data: {},
      activeName: '基本信息',
      noImg: require('@/assets/no-img.jpg'),
      name: '',
    }
  },
  methods: {
    display(data) {
      this.show = true
      this.data = data.data
      this.name = data.name
    },
    copyName() {
      let clipboard = new this.Clipboard('.copy-a')
      clipboard.on('success', () => {
        this.$message.success('复制成功')
        clipboard.destroy()
      })
      clipboard.on('error', () => {
        this.$message.error('该浏览器不支持自动复制')
        clipboard.destroy()
      })
    },
  },
}
</script>

